import { ApiError, handleApiError } from '@/handleApiError'
import { parseFileName } from '@/helpers'
import api from '@/modules/product/api'
import FileSaver from 'file-saver'
import { defineStore } from 'pinia'
import { t } from '@/plugins/i18n.ts'

interface ProductDatasheetState {
  loadingHTML: boolean
  loadingPDF: boolean
}

const initialState = (): ProductDatasheetState => {
  return {
    loadingHTML: false,
    loadingPDF: false
  }
}

const useProductDatasheet = defineStore('productDatasheet', {
  state: () => initialState(),
  actions: {
    async loadHTMLDatasheet(id: number) {
      this.loadingHTML = true

      return api
        .loadDatasheet(id, 'html')
        .then((response) => {
          window.open(URL.createObjectURL(response.data), '_blank')
        })
        .catch((error: ApiError) => {
          handleApiError(
            error,
            { customMessage: t('datasheetError') },
            { errorCode: 404, logError: false, customMessage: t('datasheetNotFound') }
          )
        })
        .finally(() => (this.loadingHTML = false))
    },
    async loadPDFDatasheet(id: number) {
      this.loadingPDF = true

      return api
        .loadDatasheet(id, 'pdf')
        .then((response) => {
          FileSaver.saveAs(response.data, parseFileName(response.headers))
        })
        .catch((error: ApiError) => {
          handleApiError(
            error,
            { customMessage: t('datasheetError') },
            { errorCode: 404, logError: false, customMessage: t('datasheetNotFound') }
          )
        })
        .finally(() => (this.loadingPDF = false))
    }
  }
})

export default useProductDatasheet
